import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { InventoryModel, InventoryPaths, InventoryEntities } from 'client/data/models/inventory';
import { DealerFeesModal } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-modal';
import { DealerFeesModalLoader } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-modal-loader';
import { DealerFeesPriceDetailsAsync } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-price-details-async';

export const DealerFeesLinkModalUI = memo(({ fullVinData = undefined, isOpen, toggle }) => {
  const renderContent = useCallback(() => {
    return fullVinData ? (
      <DealerFeesPriceDetailsAsync vinData={fullVinData} innerClassName="px-1 py-0_5" />
    ) : (
      <DealerFeesModalLoader />
    );
  }, [fullVinData]);

  return <DealerFeesModal isOpen={isOpen} toggle={toggle} renderContent={renderContent} />;
});

DealerFeesLinkModalUI.displayName = 'DealerFeesSrpModalContentUI';

DealerFeesLinkModalUI.propTypes = {
  fullVinData: InventoryEntities.InventoryVin,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export const DealerFeesLinkModal = connectToModel(DealerFeesLinkModalUI, {
  fullVinData: bindToPath(props => InventoryPaths.buildVinPath(props.vin), InventoryModel, null, false),
});
